import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ExpandMoreRoundedIcon from "@material-ui/icons/ExpandMoreRounded";
import ExpandLessRoundedIcon from "@material-ui/icons/ExpandLessRounded";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "../../../partials/controls";
import "react-quill/dist/quill.snow.css";
import CreatableSelect from "react-select/creatable";
import { useFormik } from "formik";
import { InboxOutlined } from "@ant-design/icons";
import { UploadProps } from "antd";
import { Upload } from "antd";
import {
  getOneGatway,
  addNewGateway,
  updateGatway,
} from "../../../service/gatewayServices";
import { getAllCompanies } from "../../../service/companyService";
import { toast } from "react-toastify";
import { useHistory, useParams } from "react-router";
import Loader from "../../../common/loader";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import "./addGateway.css"; // Import the CSS file
import WhatsAppSessionManager from "./WhatsAppSessionManager";

interface Values {
  gatewayName: string;
  companyId: any;
  type: string;
  connectionURL: string;
  loginName: string;
  password: string;
  port: string;
  otherKey: string;
  enabled: boolean;
  recieverInfoURL: string;
  authKey: string;
  authValue: string;
  template_name: string;
  lang_code: string;
  registeredUUIDs: { uuid: string; phone: string }[];
  actionOnMessageReceived: string;
  actionWebhookConfig: {
    url: string;
    method: string;
    headers: { key: string; value: string }[];
    body: { key: string; value: string }[];
    returnDataType: string;
  };
  apiAuthType: string;
  actionOnMessageSent: string;
  actionSentWebhookConfig: {
    url: string;
    method: string;
    headers: { key: string; value: string }[];
    body: { key: string; value: string }[];
    returnDataType: string;
  };
  apiAuthTypeSent: string;
  actionOnMessageAck: string;
  actionAckWebhookConfig: {
    url: string;
    method: string;
    headers: { key: string; value: string }[];
    body: { key: string; value: string }[];
    returnDataType: string;
    enabledStatuses: string[];
  };
  apiAuthTypeAck: string;
}

interface Params {
  id?: string;
}

const { Dragger } = Upload;

const AddGateway = () => {
  const history = useHistory();
  const [gateway, setGateway] = useState<any>({});

  const [loader, setLoader] = useState<boolean>(false);
  const params: Params = useParams();
  const [selectedFile, setSelectedFile] = useState<any>([]);
  const [isSwitchOn, setIsSwitchOn] = useState<boolean>(true);
  const [companyList, setCompanyList] = useState<any>([]);
  const [redirect, setRedirect] = useState<boolean>(true);

  // collapse state
  const [showReceivedSection, setShowReceivedSection] = useState(true);
  const [showSentSection, setShowSentSection] = useState(true);
  const [showReadPlayedSection, setShowReadPlayedSection] = useState(true);

  const getAllCompaniesData = () => {
    getAllCompanies()
      .then((res: any) => {
        const newOptions = res?.data?.data?.map((x) => {
          return {
            label: x?.name,
            value: x?.name,
          };
        });
        setCompanyList(newOptions || []);
      })
      .catch((err) => {});
  };

  const getOneGatewayDetails = () => {
    setLoader(true);
    getOneGatway(params?.id)
      .then((res: any) => {
        setLoader(false);
        setGateway(res?.data);
        setIsSwitchOn(Boolean(res?.data?.status === "Active"));
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  const props: UploadProps = {
    name: "file",
    action: "dummy",
    accept: "application/json",
    maxCount: 1,
    onRemove: (file) => {
      const index = selectedFile.indexOf(file);
      const newFileList = selectedFile.slice();
      newFileList.splice(index, 1);
      setSelectedFile(newFileList);
    },
    beforeUpload: (file, filess) => {
      return false;
    },
    onChange: (file) => {
      if (file.fileList) {
        setSelectedFile(file.fileList);
      }
    },
  };

  const onUpdate = (value: Values) => {
    setLoader(true);
    const formData = new FormData();
    formData.append("gatewayName", value.gatewayName);
    formData.append("companyId", value.companyId?.value);
    formData.append("type", value.type);
    formData.append("connectionURL", value.connectionURL);
    formData.append("loginName", value.loginName);
    value.registeredUUIDs.forEach((uuid, index) => {
      formData.append(`registeredUUIDs[${index}][uuid]`, uuid.uuid);
      formData.append(`registeredUUIDs[${index}][phone]`, uuid.phone);
    });
    formData.append("password", value.password);
    formData.append("port", value.port);
    formData.append("otherKey", value.otherKey);
    formData.append("recieverInfoURL", value.recieverInfoURL);
    formData.append("authKey", value.authKey);
    formData.append("authValue", value.authValue);
    formData.append("status", isSwitchOn === true ? "Active" : "Inactive");
    if (selectedFile.length) {
      formData.append("file", selectedFile[0]?.originFileObj);
    }
    if (value.type === "WHATSAPP") {
      formData.append("template_name", value.template_name);
      formData.append("lang_code", value.lang_code);
    }
    if (value.type === "WHATSAPP_WEB") {
      formData.append("actionOnMessageReceived", value.actionOnMessageReceived);
      if (value.actionOnMessageReceived !== "NONE") {
        formData.append(
          "actionWebhookConfig",
          JSON.stringify(value.actionWebhookConfig)
        );
      }
      formData.append("actionOnMessageSent", value.actionOnMessageSent);
      if (value.actionOnMessageSent !== "NONE") {
        formData.append(
          "actionSentWebhookConfig",
          JSON.stringify(value.actionSentWebhookConfig)
        );
      }
      formData.append("actionOnMessageAck", value.actionOnMessageAck);
      if (value.actionOnMessageAck !== "NONE") {
        formData.append(
          "actionAckWebhookConfig",
          JSON.stringify(value.actionAckWebhookConfig)
        );
      }
    }
    updateGatway(params.id, formData)
      .then((res: any) => {
        setLoader(false);

        toast.success("Gateway update Successful");
        if (redirect) {
          history.push("/gateway");
        }
      })
      .catch((err) => {
        setLoader(false);
        toast.error(err.response.data.message);
      })
      .finally(() => setRedirect(true));
  };

  const onSubmit = (value: Values) => {
    setLoader(true);
    const formData = new FormData();
    formData.append("gatewayName", value.gatewayName);
    formData.append("companyId", value.companyId?.value);
    formData.append("type", value.type);
    formData.append("connectionURL", value.connectionURL);
    formData.append("loginName", value.loginName);
    formData.append("password", value.password);
    formData.append("port", value.port);
    formData.append("otherKey", value.otherKey);
    formData.append("recieverInfoURL", value.recieverInfoURL || "");
    // formData.append("registeredUUIDs", value.registeredUUIDs);
    value.registeredUUIDs.forEach((uuid, index) => {
      formData.append(`registeredUUIDs[${index}][uuid]`, uuid.uuid);
      formData.append(`registeredUUIDs[${index}][phone]`, uuid.phone);
    });
    formData.append("authKey", value.authKey || "");
    formData.append("authValue", value.authValue || "");
    formData.append("status", isSwitchOn === true ? "Active" : "Inactive");
    if (selectedFile.length) {
      formData.append("file", selectedFile[0]?.originFileObj);
    }
    if (value.type === "WHATSAPP") {
      formData.append("template_name", value.template_name);
      formData.append("lang_code", value.lang_code);
    }
    if (value.type === "WHATSAPP_WEB") {
      formData.append("actionOnMessageReceived", value.actionOnMessageReceived);
      if (value.actionOnMessageReceived !== "NONE") {
        formData.append(
          "actionWebhookConfig",
          JSON.stringify(value.actionWebhookConfig)
        );
      }
      formData.append("actionOnMessageSent", value.actionOnMessageSent);
      if (value.actionOnMessageSent !== "NONE") {
        formData.append(
          "actionSentWebhookConfig",
          JSON.stringify(value.actionSentWebhookConfig)
        );
      }
      formData.append("actionOnMessageAck", value.actionOnMessageAck);
      if (value.actionOnMessageAck !== "NONE") {
        formData.append(
          "actionAckWebhookConfig",
          JSON.stringify(value.actionAckWebhookConfig)
        );
      }
    }
    addNewGateway(formData)
      .then((res: any) => {
        setLoader(false);
        toast.success("Gateway Add Successful");
        if (redirect) {
          history.push("/gateway");
        }
      })
      .catch((err) => {
        setLoader(false);
        toast.error(err.response.data.message);
      })
      .finally(() => setRedirect(true));
  };

  const companyValue = params.id
    ? { label: gateway?.companyId, value: gateway?.companyId }
    : "";

  const formik = useFormik({
    initialValues: {
      gatewayName: params.id ? gateway?.gatewayName : "",
      companyId: companyValue,
      type: params.id ? gateway?.type : "SMS",
      connectionURL: params.id ? gateway?.connectionURL : "",
      loginName: params.id ? gateway?.loginName : "",
      password: params.id ? gateway?.password : "",
      port: params.id ? gateway?.port : "",
      otherKey: params.id ? gateway?.otherKey : "",
      recieverInfoURL: params.id
        ? gateway?.recieverInfoURL
          ? gateway?.recieverInfoURL
          : ""
        : "",
      authKey: params.id ? (gateway?.authKey ? gateway?.authKey : "") : "",
      authValue: params.id
        ? gateway?.authValue
          ? gateway?.authValue
          : ""
        : "",
      enabled: params.id ? Boolean(gateway?.enabled === "Active") : true,
      template_name: params.id ? gateway?.template_name : "",
      lang_code: params.id ? gateway?.lang_code : "",
      registeredUUIDs: params.id ? gateway?.registeredUUIDs : [],
      actionOnMessageReceived: params.id
        ? gateway?.actionOnMessageReceived || "NONE"
        : "NONE",
      actionWebhookConfig:
        params.id && gateway?.actionWebhookConfig
          ? {
              url: gateway.actionWebhookConfig.url || "",
              method: gateway.actionWebhookConfig.method || "POST",
              headers: gateway.actionWebhookConfig.headers || [],
              body: gateway.actionWebhookConfig.body || [],
              returnDataType:
                gateway.actionWebhookConfig.returnDataType || "simplified",
            }
          : {
              url: "",
              method: "POST",
              headers: [],
              body: [],
              returnDataType: "simplified",
            },
      apiAuthType:
        params.id && gateway?.actionWebhookConfig?.headers?.length > 0
          ? "header"
          : "body",
      actionOnMessageSent: params.id
        ? gateway?.actionOnMessageSent || "NONE"
        : "NONE",
      actionSentWebhookConfig:
        params.id && gateway?.actionSentWebhookConfig
          ? {
              url: gateway.actionSentWebhookConfig.url || "",
              method: gateway.actionSentWebhookConfig.method || "POST",
              headers: gateway.actionSentWebhookConfig.headers || [],
              body: gateway.actionSentWebhookConfig.body || [],
              returnDataType:
                gateway.actionSentWebhookConfig.returnDataType || "simplified",
            }
          : {
              url: "",
              method: "POST",
              headers: [],
              body: [],
              returnDataType: "simplified",
            },
      apiAuthTypeSent:
        params.id && gateway?.actionSentWebhookConfig?.headers?.length > 0
          ? "header"
          : "body",
      actionOnMessageAck: params.id
        ? gateway?.actionOnMessageAck || "NONE"
        : "NONE",
      actionAckWebhookConfig:
        params.id && gateway?.actionAckWebhookConfig
          ? {
              url: gateway.actionAckWebhookConfig.url || "",
              method: gateway.actionAckWebhookConfig.method || "POST",
              headers: gateway.actionAckWebhookConfig.headers || [],
              body: gateway.actionAckWebhookConfig.body || [],
              returnDataType:
                gateway.actionAckWebhookConfig.returnDataType || "simplified",
              enabledStatuses: gateway.actionAckWebhookConfig
                .enabledStatuses || [
                "pending",
                "server_received",
                "delivered",
                "read",
                "played",
              ],
            }
          : {
              url: "",
              method: "POST",
              headers: [],
              body: [],
              returnDataType: "simplified",
              enabledStatuses: [
                "pending",
                "server_received",
                "delivered",
                "read",
                "played",
              ],
            },
      apiAuthTypeAck:
        params.id && gateway?.actionAckWebhookConfig?.headers?.length > 0
          ? "header"
          : "body",
    },
    enableReinitialize: true,
    onSubmit: (values: Values) => {
      const submitValues = mapWhatsappWebValues(values);
      params.id ? onUpdate(submitValues) : onSubmit(submitValues);
    },
  });

  const onSwitchAction = () => {
    setIsSwitchOn(!isSwitchOn);
  };

  useEffect(() => {
    if (params.id) {
      getOneGatewayDetails();
    }
    getAllCompaniesData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  useEffect(() => {
    if (params.id && gateway) {
      if (gateway.actionOnMessageReceived === "NONE") {
        setShowReceivedSection(false);
      }
      if (gateway.actionOnMessageSent === "NONE") {
        setShowSentSection(false);
      }
      if (gateway.actionOnMessageAck === "NONE") {
        setShowReadPlayedSection(false);
      }
    }
  }, [params.id, gateway]);

  // Gateway form mapping function (for whatsapp web)
  function mapWhatsappWebValues(values) {
    const {
      actionWebhookConfig,
      apiAuthType,
      actionOnMessageReceived,
      actionSentWebhookConfig,
      apiAuthTypeSent,
      actionOnMessageSent,
      actionAckWebhookConfig,
      apiAuthTypeAck,
      actionOnMessageAck,
      ...rest
    } = values;

    let mapped = { ...rest };

    // Only handle WHATSAPP_WEB
    if (values.type === "WHATSAPP_WEB") {
      // received
      let newActionWebhookConfig = { ...actionWebhookConfig };
      if (apiAuthType === "header") {
        newActionWebhookConfig.body = [];
        if (
          !actionWebhookConfig.headers[0] ||
          !actionWebhookConfig.headers[0].key ||
          !actionWebhookConfig.headers[0].value
        ) {
          newActionWebhookConfig.headers = [];
        } else {
          newActionWebhookConfig.headers = [actionWebhookConfig.headers[0]];
        }
      } else {
        newActionWebhookConfig.headers = [];
        if (
          !actionWebhookConfig.body[0] ||
          !actionWebhookConfig.body[0].key ||
          !actionWebhookConfig.body[0].value
        ) {
          newActionWebhookConfig.body = [];
        } else {
          newActionWebhookConfig.body = [actionWebhookConfig.body[0]];
        }
      }
      mapped.actionOnMessageReceived = actionOnMessageReceived;
      mapped.actionWebhookConfig = newActionWebhookConfig;

      // sent
      let newActionSentWebhookConfig = { ...actionSentWebhookConfig };
      if (apiAuthTypeSent === "header") {
        newActionSentWebhookConfig.body = [];
        if (
          !actionSentWebhookConfig.headers[0] ||
          !actionSentWebhookConfig.headers[0].key ||
          !actionSentWebhookConfig.headers[0].value
        ) {
          newActionSentWebhookConfig.headers = [];
        } else {
          newActionSentWebhookConfig.headers = [
            actionSentWebhookConfig.headers[0],
          ];
        }
      } else {
        newActionSentWebhookConfig.headers = [];
        if (
          !actionSentWebhookConfig.body[0] ||
          !actionSentWebhookConfig.body[0].key ||
          !actionSentWebhookConfig.body[0].value
        ) {
          newActionSentWebhookConfig.body = [];
        } else {
          newActionSentWebhookConfig.body = [actionSentWebhookConfig.body[0]];
        }
      }
      mapped.actionOnMessageSent = actionOnMessageSent;
      mapped.actionSentWebhookConfig = newActionSentWebhookConfig;

      // read/played
      let newActionAckWebhookConfig = { ...actionAckWebhookConfig };
      if (apiAuthTypeAck === "header") {
        newActionAckWebhookConfig.body = [];
        if (
          !actionAckWebhookConfig.headers[0] ||
          !actionAckWebhookConfig.headers[0].key ||
          !actionAckWebhookConfig.headers[0].value
        ) {
          newActionAckWebhookConfig.headers = [];
        } else {
          newActionAckWebhookConfig.headers = [
            actionAckWebhookConfig.headers[0],
          ];
        }
      } else {
        newActionAckWebhookConfig.headers = [];
        if (
          !actionAckWebhookConfig.body[0] ||
          !actionAckWebhookConfig.body[0].key ||
          !actionAckWebhookConfig.body[0].value
        ) {
          newActionAckWebhookConfig.body = [];
        } else {
          newActionAckWebhookConfig.body = [actionAckWebhookConfig.body[0]];
        }
      }
      mapped.actionOnMessageAck = actionOnMessageAck;
      mapped.actionAckWebhookConfig = newActionAckWebhookConfig;
    }
    return mapped;
  }
  /** END of method and events for whatsapp web */

  return (
    <div>
      <Card>
        {loader && <Loader />}
        <CardHeader
          title={params?.id ? "Edit Gateway" : "New Gateway"}
        ></CardHeader>
        <CardBody>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="col-lg-4 ws-nowrap">Gateway Name</div>
              <div className="col-lg-8">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    id="title"
                    name="gatewayName"
                    value={formik.values.gatewayName}
                    onChange={formik.handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="col-lg-4 ws-nowrap">Company</div>
              <div className="col-lg-8">
                <div className="form-group">
                  <CreatableSelect
                    options={companyList}
                    isClearable={false}
                    className="react-select"
                    classNamePrefix="select"
                    onChange={(opt: any) => {
                      formik.setFieldValue("companyId", opt);
                    }}
                    value={formik.values.companyId}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="col-lg-4 ws-nowrap">Type</div>
              <div className="col-lg-8">
                <div className="form-group">
                  <select
                    className="form-control"
                    id="title"
                    name="type"
                    value={formik.values.type}
                    onChange={formik.handleChange}
                  >
                    <option value="SMS">SMS</option>
                    <option value="WHATSAPP">Whatsapp</option>
                    <option value="WHATSAPP_WEB">Whatsapp Web</option>
                    <option value="EMAIL">Email</option>
                    <option value="PUSH NOTIFICATION">
                      Push Notification (IOS & Android)
                    </option>
                  </select>
                  <ExpandMoreRoundedIcon
                    style={{
                      position: "absolute",
                      right: "20px",
                      top: "10px",
                    }}
                  />
                </div>
              </div>
            </div>
            {formik.values.type === "SMS" ? (
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="col-lg-4 ws-nowrap">
                  Phone (twillio/firebase)
                </div>
                <div className="col-lg-8">
                  <div className="form-group">
                    <input
                      className="form-control"
                      id="title"
                      name="otherKey"
                      value={formik.values.otherKey}
                      onChange={formik.handleChange}
                    />
                  </div>
                </div>
              </div>
            ) : null}
            {formik.values.type === "EMAIL" ? (
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="col-lg-4 ws-nowrap ">Connection URL</div>
                <div className="col-lg-8">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      id="title"
                      name="connectionURL"
                      value={formik.values.connectionURL}
                      onChange={formik.handleChange}
                    />
                  </div>
                </div>
              </div>
            ) : null}
            {formik.values.type === "PUSH NOTIFICATION" ? (
              <div className="col-lg-10 col-md-10 col-sm-12 ">
                <div className="col-lg-4 ws-nowrap">Firebase JSON</div>
                <div className="col-lg-12 ws-nowrap">
                  <div className="form-group">
                    <Dragger {...props}>
                      <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                      </p>
                      <p className="ant-upload-text">
                        Click or drag file to this area to upload
                      </p>
                    </Dragger>
                  </div>
                </div>
              </div>
            ) : null}
            {formik.values.type === "PUSH NOTIFICATION" ||
            formik.values.type === "WHATSAPP_WEB" ? null : (
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="col-lg-4 ws-nowrap">
                  {formik.values.type === "SMS"
                    ? "SID"
                    : formik.values.type === "WHATSAPP" ||
                      formik.values.type === "WHATS"
                    ? "PhoneNumberID"
                    : "Login Name"}
                </div>
                <div className="col-lg-8">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      id="title"
                      name="loginName"
                      value={formik.values.loginName}
                      onChange={formik.handleChange}
                    />
                  </div>
                </div>
              </div>
            )}
            {formik.values.type === "PUSH NOTIFICATION" ||
            formik.values.type === "WHATSAPP_WEB" ? null : (
              <div
                className={
                  formik.values.type === "WHATSAPP"
                    ? "col-lg-12 col-md-12 col-sm-12"
                    : "col-lg-6 col-md-6 col-sm-12"
                }
              >
                <div className="col-lg-4 ws-nowrap">
                  {formik.values.type === "SMS"
                    ? "Auth Token"
                    : formik.values.type === "WHATSAPP"
                    ? "Access Token"
                    : "Password"}
                </div>
                <div
                  className={
                    formik.values.type === "WHATSAPP" ? "col-lg-10" : "col-lg-8"
                  }
                >
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      id="title"
                      name="password"
                      value={formik.values.password}
                      onChange={formik.handleChange}
                    />
                  </div>
                </div>
              </div>
            )}
            {formik.values.type === "WHATSAPP" ? (
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="col-lg-4 ws-nowrap">Template Name</div>
                <div className="col-lg-8">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      id="title"
                      name="template_name"
                      value={formik.values.template_name}
                      onChange={formik.handleChange}
                    />
                  </div>
                </div>
              </div>
            ) : null}
            {formik.values.type === "WHATSAPP" ? (
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="col-lg-4 ws-nowrap">Language Code</div>
                <div className="col-lg-8">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      id="title"
                      name="lang_code"
                      value={formik.values.lang_code}
                      onChange={formik.handleChange}
                    />
                  </div>
                </div>
              </div>
            ) : null}
            {formik.values.type === "WHATSAPP_WEB" && (
              <>
                {/* Sent Webhook Section */}
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="gateway-section-dark">
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: 16,
                        marginBottom: 12,
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                      onClick={() => setShowSentSection((v) => !v)}
                    >
                      <span>Webhook: When Message Sent</span>
                      {showSentSection ? (
                        <ExpandLessRoundedIcon />
                      ) : (
                        <ExpandMoreRoundedIcon />
                      )}
                    </div>
                    <div
                      className={`collapsible-content${
                        showSentSection ? "" : " collapsed"
                      }`}
                    >
                      <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="col-lg-4 ws-nowrap">
                            Action When Message Sent
                          </div>
                          <div className="col-lg-8">
                            <div className="form-group">
                              <select
                                className="form-control"
                                id="actionOnMessageSent"
                                name="actionOnMessageSent"
                                value={formik.values.actionOnMessageSent}
                                onChange={formik.handleChange}
                              >
                                <option value="NONE">None</option>
                                <option value="CALL_WEBHOOK">
                                  Call Webhook
                                </option>
                              </select>
                              <ExpandMoreRoundedIcon
                                style={{
                                  position: "absolute",
                                  right: "20px",
                                  top: "10px",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12" />
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="col-lg-4 ws-nowrap">
                            Webhook Method
                          </div>
                          <div className="col-lg-8">
                            <div className="form-group">
                              <select
                                className="form-control"
                                id="actionSentWebhookConfig.method"
                                name="actionSentWebhookConfig.method"
                                value={
                                  formik.values.actionSentWebhookConfig.method
                                }
                                onChange={formik.handleChange}
                                disabled={
                                  formik.values.actionOnMessageSent !==
                                  "CALL_WEBHOOK"
                                }
                              >
                                <option value="GET">GET</option>
                                <option value="POST">POST</option>
                                <option value="PUT">PUT</option>
                                <option value="DELETE">DELETE</option>
                              </select>
                              <ExpandMoreRoundedIcon
                                style={{
                                  position: "absolute",
                                  right: "20px",
                                  top: "10px",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="col-lg-4 ws-nowrap">
                            Webhook Payload Detail Level
                          </div>
                          <div className="col-lg-8">
                            <div className="form-group">
                              <select
                                className="form-control"
                                id="actionSentWebhookConfig.returnDataType"
                                name="actionSentWebhookConfig.returnDataType"
                                value={
                                  formik.values.actionSentWebhookConfig
                                    .returnDataType
                                }
                                onChange={formik.handleChange}
                                disabled={
                                  formik.values.actionOnMessageSent !==
                                  "CALL_WEBHOOK"
                                }
                              >
                                <option value="simplified">
                                  Simplified（Basic fields only）
                                </option>
                                <option value="detailed">
                                  Detailed（All message details）
                                </option>
                              </select>
                              <ExpandMoreRoundedIcon
                                style={{
                                  position: "absolute",
                                  right: "20px",
                                  top: "10px",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12">
                          <div className="col-lg-4 ws-nowrap">Webhook URL</div>
                          <div className="col-lg-10">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control"
                                id="actionSentWebhookConfig.url"
                                name="actionSentWebhookConfig.url"
                                value={
                                  formik.values.actionSentWebhookConfig.url
                                }
                                onChange={formik.handleChange}
                                disabled={
                                  formik.values.actionOnMessageSent !==
                                  "CALL_WEBHOOK"
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="col-lg-4 ws-nowrap">Auth Type</div>
                          <div className="col-lg-8">
                            <div className="form-group">
                              <select
                                className="form-control"
                                id="apiAuthTypeSent"
                                name="apiAuthTypeSent"
                                value={formik.values.apiAuthTypeSent}
                                onChange={(e) => {
                                  const type = e.target.value;
                                  formik.setFieldValue("apiAuthTypeSent", type);
                                  if (type === "header") {
                                    // copy from body to header
                                    const bodyKV =
                                      formik.values.actionSentWebhookConfig
                                        .body[0];
                                    if (
                                      bodyKV &&
                                      (bodyKV.key || bodyKV.value)
                                    ) {
                                      formik.setFieldValue(
                                        "actionSentWebhookConfig.headers",
                                        [
                                          {
                                            key: bodyKV.key || "",
                                            value: bodyKV.value || "",
                                          },
                                        ]
                                      );
                                    }
                                    formik.setFieldValue(
                                      "actionSentWebhookConfig.body",
                                      []
                                    );
                                  } else {
                                    // copy from header to body
                                    const headerKV =
                                      formik.values.actionSentWebhookConfig
                                        .headers[0];
                                    if (
                                      headerKV &&
                                      (headerKV.key || headerKV.value)
                                    ) {
                                      formik.setFieldValue(
                                        "actionSentWebhookConfig.body",
                                        [
                                          {
                                            key: headerKV.key || "",
                                            value: headerKV.value || "",
                                          },
                                        ]
                                      );
                                    }
                                    formik.setFieldValue(
                                      "actionSentWebhookConfig.headers",
                                      []
                                    );
                                  }
                                }}
                                disabled={
                                  formik.values.actionOnMessageSent !==
                                  "CALL_WEBHOOK"
                                }
                              >
                                <option value="header">Header</option>
                                <option value="body">Body</option>
                              </select>
                              <ExpandMoreRoundedIcon
                                style={{
                                  position: "absolute",
                                  right: "20px",
                                  top: "10px",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12" />
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="col-lg-4 ws-nowrap">Auth Name</div>
                          <div className="col-lg-8">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control"
                                id="authNameSent"
                                name="authNameSent"
                                value={
                                  formik.values.apiAuthTypeSent === "header"
                                    ? formik.values.actionSentWebhookConfig
                                        .headers[0]?.key || ""
                                    : formik.values.actionSentWebhookConfig
                                        .body[0]?.key || ""
                                }
                                onChange={(e) => {
                                  if (
                                    formik.values.apiAuthTypeSent === "header"
                                  ) {
                                    formik.setFieldValue(
                                      "actionSentWebhookConfig.headers",
                                      [
                                        {
                                          key: e.target.value,
                                          value:
                                            formik.values
                                              .actionSentWebhookConfig
                                              .headers[0]?.value || "",
                                        },
                                      ]
                                    );
                                  } else {
                                    formik.setFieldValue(
                                      "actionSentWebhookConfig.body",
                                      [
                                        {
                                          key: e.target.value,
                                          value:
                                            formik.values
                                              .actionSentWebhookConfig.body[0]
                                              ?.value || "",
                                        },
                                      ]
                                    );
                                  }
                                }}
                                disabled={
                                  formik.values.actionOnMessageSent !==
                                  "CALL_WEBHOOK"
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="col-lg-4 ws-nowrap">Auth Value</div>
                          <div className="col-lg-8">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control"
                                id="authValueSent"
                                name="authValueSent"
                                value={
                                  formik.values.apiAuthTypeSent === "header"
                                    ? formik.values.actionSentWebhookConfig
                                        .headers[0]?.value || ""
                                    : formik.values.actionSentWebhookConfig
                                        .body[0]?.value || ""
                                }
                                onChange={(e) => {
                                  if (
                                    formik.values.apiAuthTypeSent === "header"
                                  ) {
                                    formik.setFieldValue(
                                      "actionSentWebhookConfig.headers",
                                      [
                                        {
                                          key:
                                            formik.values
                                              .actionSentWebhookConfig
                                              .headers[0]?.key || "",
                                          value: e.target.value,
                                        },
                                      ]
                                    );
                                  } else {
                                    formik.setFieldValue(
                                      "actionSentWebhookConfig.body",
                                      [
                                        {
                                          key:
                                            formik.values
                                              .actionSentWebhookConfig.body[0]
                                              ?.key || "",
                                          value: e.target.value,
                                        },
                                      ]
                                    );
                                  }
                                }}
                                disabled={
                                  formik.values.actionOnMessageSent !==
                                  "CALL_WEBHOOK"
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Received Webhook Section */}
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="gateway-section-dark">
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: 16,
                        marginBottom: 12,
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                      onClick={() => setShowReceivedSection((v) => !v)}
                    >
                      <span>Webhook: When Message Received</span>
                      {showReceivedSection ? (
                        <ExpandLessRoundedIcon />
                      ) : (
                        <ExpandMoreRoundedIcon />
                      )}
                    </div>
                    <div
                      className={`collapsible-content${
                        showReceivedSection ? "" : " collapsed"
                      }`}
                    >
                      <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="col-lg-4 ws-nowrap">
                            Action When Message Received
                          </div>
                          <div className="col-lg-8">
                            <div className="form-group">
                              <select
                                className="form-control"
                                id="actionOnMessageReceived"
                                name="actionOnMessageReceived"
                                value={formik.values.actionOnMessageReceived}
                                onChange={formik.handleChange}
                              >
                                <option value="NONE">None</option>
                                <option value="CALL_WEBHOOK">
                                  Call Webhook
                                </option>
                              </select>
                              <ExpandMoreRoundedIcon
                                style={{
                                  position: "absolute",
                                  right: "20px",
                                  top: "10px",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12" />
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="col-lg-4 ws-nowrap">
                            Webhook Method
                          </div>
                          <div className="col-lg-8">
                            <div className="form-group">
                              <select
                                className="form-control"
                                id="actionWebhookConfig.method"
                                name="actionWebhookConfig.method"
                                value={formik.values.actionWebhookConfig.method}
                                onChange={formik.handleChange}
                                disabled={
                                  formik.values.actionOnMessageReceived !==
                                  "CALL_WEBHOOK"
                                }
                              >
                                <option value="GET">GET</option>
                                <option value="POST">POST</option>
                                <option value="PUT">PUT</option>
                                <option value="DELETE">DELETE</option>
                              </select>
                              <ExpandMoreRoundedIcon
                                style={{
                                  position: "absolute",
                                  right: "20px",
                                  top: "10px",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="col-lg-4 ws-nowrap">
                            Webhook Payload Detail Level
                          </div>
                          <div className="col-lg-8">
                            <div className="form-group">
                              <select
                                className="form-control"
                                id="actionWebhookConfig.returnDataType"
                                name="actionWebhookConfig.returnDataType"
                                value={
                                  formik.values.actionWebhookConfig
                                    .returnDataType
                                }
                                onChange={formik.handleChange}
                                disabled={
                                  formik.values.actionOnMessageReceived !==
                                  "CALL_WEBHOOK"
                                }
                              >
                                <option value="simplified">
                                  Simplified（Basic fields only）
                                </option>
                                <option value="detailed">
                                  Detailed（All message details）
                                </option>
                              </select>
                              <ExpandMoreRoundedIcon
                                style={{
                                  position: "absolute",
                                  right: "20px",
                                  top: "10px",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12">
                          <div className="col-lg-4 ws-nowrap">Webhook URL</div>
                          <div className="col-lg-10">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control"
                                id="actionWebhookConfig.url"
                                name="actionWebhookConfig.url"
                                value={formik.values.actionWebhookConfig.url}
                                onChange={formik.handleChange}
                                disabled={
                                  formik.values.actionOnMessageReceived !==
                                  "CALL_WEBHOOK"
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="col-lg-4 ws-nowrap">Auth Type</div>
                          <div className="col-lg-8">
                            <div className="form-group">
                              <select
                                className="form-control"
                                id="apiAuthType"
                                name="apiAuthType"
                                value={formik.values.apiAuthType}
                                onChange={(e) => {
                                  const type = e.target.value;
                                  formik.setFieldValue("apiAuthType", type);
                                  if (type === "header") {
                                    // copy from body to header
                                    const bodyKV =
                                      formik.values.actionWebhookConfig.body[0];
                                    if (
                                      bodyKV &&
                                      (bodyKV.key || bodyKV.value)
                                    ) {
                                      formik.setFieldValue(
                                        "actionWebhookConfig.headers",
                                        [
                                          {
                                            key: bodyKV.key || "",
                                            value: bodyKV.value || "",
                                          },
                                        ]
                                      );
                                    }
                                    formik.setFieldValue(
                                      "actionWebhookConfig.body",
                                      []
                                    );
                                  } else {
                                    // copy from header to body
                                    const headerKV =
                                      formik.values.actionWebhookConfig
                                        .headers[0];
                                    if (
                                      headerKV &&
                                      (headerKV.key || headerKV.value)
                                    ) {
                                      formik.setFieldValue(
                                        "actionWebhookConfig.body",
                                        [
                                          {
                                            key: headerKV.key || "",
                                            value: headerKV.value || "",
                                          },
                                        ]
                                      );
                                    }
                                    formik.setFieldValue(
                                      "actionWebhookConfig.headers",
                                      []
                                    );
                                  }
                                }}
                                disabled={
                                  formik.values.actionOnMessageReceived !==
                                  "CALL_WEBHOOK"
                                }
                              >
                                <option value="header">Header</option>
                                <option value="body">Body</option>
                              </select>
                              <ExpandMoreRoundedIcon
                                style={{
                                  position: "absolute",
                                  right: "20px",
                                  top: "10px",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12" />
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="col-lg-4 ws-nowrap">Auth Name</div>
                          <div className="col-lg-8">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control"
                                id="authName"
                                name="authName"
                                value={
                                  formik.values.apiAuthType === "header"
                                    ? formik.values.actionWebhookConfig
                                        .headers[0]?.key || ""
                                    : formik.values.actionWebhookConfig.body[0]
                                        ?.key || ""
                                }
                                onChange={(e) => {
                                  if (formik.values.apiAuthType === "header") {
                                    formik.setFieldValue(
                                      "actionWebhookConfig.headers",
                                      [
                                        {
                                          key: e.target.value,
                                          value:
                                            formik.values.actionWebhookConfig
                                              .headers[0]?.value || "",
                                        },
                                      ]
                                    );
                                  } else {
                                    formik.setFieldValue(
                                      "actionWebhookConfig.body",
                                      [
                                        {
                                          key: e.target.value,
                                          value:
                                            formik.values.actionWebhookConfig
                                              .body[0]?.value || "",
                                        },
                                      ]
                                    );
                                  }
                                }}
                                disabled={
                                  formik.values.actionOnMessageReceived !==
                                  "CALL_WEBHOOK"
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="col-lg-4 ws-nowrap">Auth Value</div>
                          <div className="col-lg-8">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control"
                                id="authValue"
                                name="authValue"
                                value={
                                  formik.values.apiAuthType === "header"
                                    ? formik.values.actionWebhookConfig
                                        .headers[0]?.value || ""
                                    : formik.values.actionWebhookConfig.body[0]
                                        ?.value || ""
                                }
                                onChange={(e) => {
                                  if (formik.values.apiAuthType === "header") {
                                    formik.setFieldValue(
                                      "actionWebhookConfig.headers",
                                      [
                                        {
                                          key:
                                            formik.values.actionWebhookConfig
                                              .headers[0]?.key || "",
                                          value: e.target.value,
                                        },
                                      ]
                                    );
                                  } else {
                                    formik.setFieldValue(
                                      "actionWebhookConfig.body",
                                      [
                                        {
                                          key:
                                            formik.values.actionWebhookConfig
                                              .body[0]?.key || "",
                                          value: e.target.value,
                                        },
                                      ]
                                    );
                                  }
                                }}
                                disabled={
                                  formik.values.actionOnMessageReceived !==
                                  "CALL_WEBHOOK"
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Read/Played Webhook Section */}
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="gateway-section-dark">
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: 16,
                        marginBottom: 12,
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                      onClick={() => setShowReadPlayedSection((v) => !v)}
                    >
                      <span>Webhook: When Message Status Updated</span>
                      {showReadPlayedSection ? (
                        <ExpandLessRoundedIcon />
                      ) : (
                        <ExpandMoreRoundedIcon />
                      )}
                    </div>
                    <div
                      className={`collapsible-content${
                        showReadPlayedSection ? "" : " collapsed"
                      }`}
                    >
                      <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="col-lg-4 ws-nowrap">
                            Action When Message Status Updated
                          </div>
                          <div className="col-lg-8">
                            <div className="form-group">
                              <select
                                className="form-control"
                                id="actionOnMessageAck"
                                name="actionOnMessageAck"
                                value={formik.values.actionOnMessageAck}
                                onChange={formik.handleChange}
                              >
                                <option value="NONE">None</option>
                                <option value="CALL_WEBHOOK">
                                  Call Webhook
                                </option>
                              </select>
                              <ExpandMoreRoundedIcon
                                style={{
                                  position: "absolute",
                                  right: "20px",
                                  top: "10px",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12" />
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="col-lg-4 ws-nowrap">
                            Webhook Method
                          </div>
                          <div className="col-lg-8">
                            <div className="form-group">
                              <select
                                className="form-control"
                                id="actionAckWebhookConfig.method"
                                name="actionAckWebhookConfig.method"
                                value={
                                  formik.values.actionAckWebhookConfig.method
                                }
                                onChange={formik.handleChange}
                                disabled={
                                  formik.values.actionOnMessageAck !==
                                  "CALL_WEBHOOK"
                                }
                              >
                                <option value="GET">GET</option>
                                <option value="POST">POST</option>
                                <option value="PUT">PUT</option>
                                <option value="DELETE">DELETE</option>
                              </select>
                              <ExpandMoreRoundedIcon
                                style={{
                                  position: "absolute",
                                  right: "20px",
                                  top: "10px",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="col-lg-4 ws-nowrap">
                            Webhook Payload Detail Level
                          </div>
                          <div className="col-lg-8">
                            <div className="form-group">
                              <select
                                className="form-control"
                                id="actionAckWebhookConfig.returnDataType"
                                name="actionAckWebhookConfig.returnDataType"
                                value={
                                  formik.values.actionAckWebhookConfig
                                    .returnDataType
                                }
                                onChange={formik.handleChange}
                                disabled={
                                  formik.values.actionOnMessageAck !==
                                  "CALL_WEBHOOK"
                                }
                              >
                                <option value="simplified">
                                  Simplified（Basic fields only）
                                </option>
                                <option value="detailed">
                                  Detailed（All message details）
                                </option>
                              </select>
                              <ExpandMoreRoundedIcon
                                style={{
                                  position: "absolute",
                                  right: "20px",
                                  top: "10px",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12">
                          <div className="col-lg-4 ws-nowrap">
                            Statuses That Trigger Webhook
                          </div>
                          <div className="col-lg-10">
                            <div className="form-group">
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "10px",
                                  alignItems: "center",
                                }}
                              >
                                {[
                                  "pending",
                                  "server_received",
                                  "delivered",
                                  "read",
                                  "played",
                                ].map((status) => (
                                  <label
                                    key={status}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      margin: "5px 10px 5px 0",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={formik.values.actionAckWebhookConfig.enabledStatuses.includes(
                                        status
                                      )}
                                      onChange={(e) => {
                                        const currentStatuses =
                                          formik.values.actionAckWebhookConfig
                                            .enabledStatuses;
                                        if (e.target.checked) {
                                          formik.setFieldValue(
                                            "actionAckWebhookConfig.enabledStatuses",
                                            [...currentStatuses, status]
                                          );
                                        } else {
                                          formik.setFieldValue(
                                            "actionAckWebhookConfig.enabledStatuses",
                                            currentStatuses.filter(
                                              (s) => s !== status
                                            )
                                          );
                                        }
                                      }}
                                      disabled={
                                        formik.values.actionOnMessageAck !==
                                        "CALL_WEBHOOK"
                                      }
                                      style={{ marginRight: "5px" }}
                                    />
                                    <span
                                      style={{
                                        textTransform: "capitalize",
                                        fontSize: "14px",
                                        color:
                                          formik.values.actionOnMessageAck !==
                                          "CALL_WEBHOOK"
                                            ? "#999"
                                            : "#333",
                                      }}
                                    >
                                      {status.replace("_", " ")}
                                    </span>
                                  </label>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12">
                          <div className="col-lg-4 ws-nowrap">Webhook URL</div>
                          <div className="col-lg-10">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control"
                                id="actionAckWebhookConfig.url"
                                name="actionAckWebhookConfig.url"
                                value={formik.values.actionAckWebhookConfig.url}
                                onChange={formik.handleChange}
                                disabled={
                                  formik.values.actionOnMessageAck !==
                                  "CALL_WEBHOOK"
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="col-lg-4 ws-nowrap">Auth Type</div>
                          <div className="col-lg-8">
                            <div className="form-group">
                              <select
                                className="form-control"
                                id="apiAuthTypeAck"
                                name="apiAuthTypeAck"
                                value={formik.values.apiAuthTypeAck}
                                onChange={(e) => {
                                  const type = e.target.value;
                                  formik.setFieldValue("apiAuthTypeAck", type);
                                  if (type === "header") {
                                    const bodyKV =
                                      formik.values.actionAckWebhookConfig
                                        .body[0];
                                    if (
                                      bodyKV &&
                                      (bodyKV.key || bodyKV.value)
                                    ) {
                                      formik.setFieldValue(
                                        "actionAckWebhookConfig.headers",
                                        [
                                          {
                                            key: bodyKV.key || "",
                                            value: bodyKV.value || "",
                                          },
                                        ]
                                      );
                                    }
                                    formik.setFieldValue(
                                      "actionAckWebhookConfig.body",
                                      []
                                    );
                                  } else {
                                    const headerKV =
                                      formik.values.actionAckWebhookConfig
                                        .headers[0];
                                    if (
                                      headerKV &&
                                      (headerKV.key || headerKV.value)
                                    ) {
                                      formik.setFieldValue(
                                        "actionAckWebhookConfig.body",
                                        [
                                          {
                                            key: headerKV.key || "",
                                            value: headerKV.value || "",
                                          },
                                        ]
                                      );
                                    }
                                    formik.setFieldValue(
                                      "actionAckWebhookConfig.headers",
                                      []
                                    );
                                  }
                                }}
                                disabled={
                                  formik.values.actionOnMessageAck !==
                                  "CALL_WEBHOOK"
                                }
                              >
                                <option value="header">Header</option>
                                <option value="body">Body</option>
                              </select>
                              <ExpandMoreRoundedIcon
                                style={{
                                  position: "absolute",
                                  right: "20px",
                                  top: "10px",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12" />
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="col-lg-4 ws-nowrap">Auth Name</div>
                          <div className="col-lg-8">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control"
                                id="authNameAck"
                                name="authNameAck"
                                value={
                                  formik.values.apiAuthTypeAck === "header"
                                    ? formik.values.actionAckWebhookConfig
                                        .headers[0]?.key || ""
                                    : formik.values.actionAckWebhookConfig
                                        .body[0]?.key || ""
                                }
                                onChange={(e) => {
                                  if (
                                    formik.values.apiAuthTypeAck === "header"
                                  ) {
                                    formik.setFieldValue(
                                      "actionAckWebhookConfig.headers",
                                      [
                                        {
                                          key: e.target.value,
                                          value:
                                            formik.values.actionAckWebhookConfig
                                              .headers[0]?.value || "",
                                        },
                                      ]
                                    );
                                  } else {
                                    formik.setFieldValue(
                                      "actionAckWebhookConfig.body",
                                      [
                                        {
                                          key: e.target.value,
                                          value:
                                            formik.values.actionAckWebhookConfig
                                              .body[0]?.value || "",
                                        },
                                      ]
                                    );
                                  }
                                }}
                                disabled={
                                  formik.values.actionOnMessageAck !==
                                  "CALL_WEBHOOK"
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="col-lg-4 ws-nowrap">Auth Value</div>
                          <div className="col-lg-8">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control"
                                id="authValueAck"
                                name="authValueAck"
                                value={
                                  formik.values.apiAuthTypeAck === "header"
                                    ? formik.values.actionAckWebhookConfig
                                        .headers[0]?.value || ""
                                    : formik.values.actionAckWebhookConfig
                                        .body[0]?.value || ""
                                }
                                onChange={(e) => {
                                  if (
                                    formik.values.apiAuthTypeAck === "header"
                                  ) {
                                    formik.setFieldValue(
                                      "actionAckWebhookConfig.headers",
                                      [
                                        {
                                          key:
                                            formik.values.actionAckWebhookConfig
                                              .headers[0]?.key || "",
                                          value: e.target.value,
                                        },
                                      ]
                                    );
                                  } else {
                                    formik.setFieldValue(
                                      "actionAckWebhookConfig.body",
                                      [
                                        {
                                          key:
                                            formik.values.actionAckWebhookConfig
                                              .body[0]?.key || "",
                                          value: e.target.value,
                                        },
                                      ]
                                    );
                                  }
                                }}
                                disabled={
                                  formik.values.actionOnMessageAck !==
                                  "CALL_WEBHOOK"
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {formik.values.type === "EMAIL" ? (
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="col-lg-4 ws-nowrap">Port</div>
                <div className="col-lg-8">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      id="title"
                      name="port"
                      value={formik.values.port}
                      onChange={formik.handleChange}
                    />
                  </div>
                </div>
              </div>
            ) : null}

            {formik.values.type !== "WHATSAPP_WEB" ? (
              <>
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="col-lg-4 ws-nowrap">Reciever Info URL</div>
                  <div className="col-lg-10">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        id="title"
                        name="recieverInfoURL"
                        value={formik.values.recieverInfoURL}
                        onChange={formik.handleChange}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="col-lg-4 ws-nowrap">Auth Header Key</div>
                  <div className="col-lg-8">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        id="title"
                        name="authKey"
                        value={formik.values.authKey}
                        onChange={formik.handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="col-lg-4 ws-nowrap">Auth Header Value</div>
                  <div className="col-lg-8">
                    <div className="form-group">
                      <input
                        className="form-control"
                        id="title"
                        name="authValue"
                        value={formik.values.authValue}
                        onChange={formik.handleChange}
                      />
                    </div>
                  </div>
                </div>
              </>
            ) : null}
          </div>

          <div className="row" style={{ marginLeft: "0.5px" }}>
            <div className="col-12 col-sm-3 mb-4 mb-sm-0 ws-nowrap d-flex justify-content-between align-items-center">
              <span>Status</span>
              <FormControlLabel
                control={
                  <Switch
                    checked={isSwitchOn}
                    onChange={onSwitchAction}
                    color="primary"
                    name="enabled"
                  />
                }
                label={isSwitchOn ? "Active" : "Inactive"}
                className="mb-0"
              />
            </div>
          </div>
        </CardBody>

        <CardFooter>
          <div className="row">
            <div className="col-lg-10">
              <div className="d-flex flex-wrap align-items-center justify-content-end">
                <div className="mt-4 mt-sm-0">
                  <button
                    className="btn btn-success mr-2 mx-sm-2"
                    onClick={() => formik.handleSubmit()}
                  >
                    Save
                  </button>
                </div>
                <div className="mt-4 mt-sm-0">
                  <Link className="btn btn-car-back" to="/gateway">
                    Back
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </CardFooter>
      </Card>
      {formik.values.type === "WHATSAPP_WEB" && (
        // TBC/TODO save when deleted / created
        <WhatsAppSessionManager
          registeredUUIDs={formik.values.registeredUUIDs || []}
          onUpdateUUIDs={(uuids) => {
            formik.setFieldValue("registeredUUIDs", uuids);
            // Auto-save gateway after session changes without redirect
            setRedirect(false);
            setTimeout(() => {
              formik.handleSubmit();
            }, 300);
          }}
          isEditMode={!!params.id}
        />
      )}
    </div>
  );
};

export default AddGateway;
